import React, { useState, useEffect } from "react";
import { Input, Button } from "antd";
import { Col, Row } from "antd";
import { AutoComplete } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "./PersonalDetails.css";
import history from "../../routes/history";
import {
  GetFilters,
  updateCompanyProfileDetails,
  getPersonalDetailsLocation,
  fetchUserProfile,
} from "../../redux/actions";
import { LoadingOutlined } from "@ant-design/icons";
import MyPersonalDetails from "../My Profile/components/personalDetails";

const PersonalDetails = () => {
  const dispatch = useDispatch();
  const [locationValue, setLocationValue] = useState("");
  const [location, setLocation] = useState([]);
  const [FirstName, setfname] = useState("");
  const [LastName, setlname] = useState("");
  const [PreferredName, setdispname] = useState("");
  const [JobTitle, setjobtitle] = useState("");
  const [EmailAddress, setemail] = useState("");
  const [MobilePhone, setphone] = useState("");
  const [AddressLine1, setaddress1] = useState("");
  const [AddressLine2, setaddress2] = useState("");
  const [city, setcity] = useState("");
  const [ZipCode, setzip] = useState("");

  const [fnameerr, setfnameerr] = useState("");
  const [lnameerr, setlnameerr] = useState("");
  const [dispnameerr, setdispnameerr] = useState("");
  const [joberr, setjoberr] = useState("");
  const [emailerr, setemailerr] = useState("");
  const [phoneerr, setphoneerr] = useState("");
  const [adderr, setadderr] = useState("");
  const [cityerr, setcityerr] = useState("");
  const [ziperr, setziperr] = useState("");
  const [error, setError] = useState(false);

  const filters = useSelector(
    (state) => state.getPersonalDetailsLocationReducer.location
  );
  const loading = useSelector(
    (state) => state.getCompanyDetailsReducer.loading
  );
  const success = useSelector(
    (state) => state.getCompanyDetailsReducer.success
  );
  const token = useSelector((state) => state.authReducer.user.authToken);

  useEffect(() => {
    dispatch(getPersonalDetailsLocation(locationValue));
  }, [locationValue]);

  useEffect(() => {
    dispatch(fetchUserProfile(token));
  }, []);

  useEffect(() => {
    var options = [];
    for (var i = 0; i < filters.length; i++) {
      // console.log('location:', filters[i].Location);
      options = [
        ...options,
        {
          value: filters[i].Location,
        },
      ];
    }

    setLocation(options);

  }, [filters.length]);

  const SubmitDetails = () => {
    var error_;

    if (FirstName == "") {
      // setError(true)
      error_ = true;
      
      setfnameerr("Add your first name");

    
    } else {
      setfnameerr("");
      // setError(false)
      error_ = false;
    }
    if (LastName == "") {
      error_ = true;
      setlnameerr("Add your last name");
      // setError(true)
    } else {
      setlnameerr("");
      // setError(false)
      error_ = false;
    }
    if (PreferredName == "") {
      setdispnameerr("Add the name you want displayed");
      // setError(true)
      error_ = true;
    } else {
      setdispnameerr("");
      // setError(false)
      error_ = false;
    }
    if (JobTitle == "") {
      setjoberr("Add the title of your gig");
      // setError(true)
      error_ = true;
    } else {
      setjoberr("");
      // setError(false)
      error_ = false;
    }
    if (EmailAddress == "") {
      setemailerr("Missing  email");
      // setError(true)
      error_ = true;
    } else {
      setemailerr("");
      // setError(false)
      error_ = false;
    }

    if (MobilePhone == "") {
      setphoneerr("Missing phone number");
      // setError(true)
      error_ = true;
    } else {
      setphoneerr("");
      // setError(false)
      error_ = false;
    }
    if (AddressLine1 == "") {
      setadderr("Add your address");
      // setError(true)
      error_ = true;
    } else {
      setadderr("");
      // setError(false)
      error_ = false;
    }

    if (locationValue == "") {
      setcityerr("Add your city and state");
      // setError(true)
      error_ = true;
    } else {
      setcityerr("");
      // setError(false)
      error_ = false;
    }
    if (ZipCode == "") {
      setziperr("Missing zip code");
      // setError(true)
      error_ = true;
    } else {
      setziperr("");
      // setError(false)
      error_ = false;
    }

    if (error_) {
      return;
    } else {
      dispatch(
        updateCompanyProfileDetails({
          FirstName,
          LastName,
          PreferredName,
          JobTitle,
          EmailAddress,
          MobilePhone,
          AddressLine1,
          AddressLine2,
          Location: locationValue,
          ZipCode,
        })
      );
    }
  };
  const onSelect = (value) => {
    setLocationValue(value);
  };

  useEffect(() => {
    if (success) {
      history.push({
        pathname: "/postjob",
        state: 
        {
          fromSignUp: true
        },
      });
    }
  }, [success]);

  return (
    <>
      <div className="container">
        {/* <div className='personal-details-text'>Add your personal details</div> */}
        <div className="form-container">
          <MyPersonalDetails buttonText="Save" />
        </div>
      </div>
    </>
  );
};

export default PersonalDetails;
